export default {
  LOGIN: "api/admin/user/autologin",
  // LOGIN: 'api/admin/user/login',
  LOGOUT: "api/admin/user/logout",
  PROFILE: "api/admin/user/profile",
  REFRESH: "api/admin/user/refresh",
  // USER
  USER_LIST: "api/admin/user",
  USER_CREATE: "api/admin/user",
  USER_DELETE: "api/admin/user/:id",
  USER_UPDATE: "api/admin/user/:id",
  USER_DETAIL: "api/admin/user/:id",
  USER_FORCE_MFA: "api/admin/user/:id/force-mfa",
  USER_ROLE: "api/admin/user/role",
  USER_CS_USER_LIST: "api/admin/user/csuser/list",
  USER_CUSTOMER_USER_LIST: "api/admin/user/customer/list",

  UPDATE_PASSWORD: "api/admin/user/updatepassword",
  // ROLE
  ROLE_LIST: "api/admin/role",
  ROLE_CREATE: "api/admin/role",
  ROLE_DELETE: "api/admin/role/:id",
  ROLE_UPDATE: "api/admin/role/:id",
  ROLE_DETAIL: "api/admin/role/:id",
  ROLE_PERMISSIONS: "api/admin/role/permissions",
  ROLE_GET_ALL: "api/admin/role/all",
  // Banner
  BANNER: "banner",
  BANNER_LIST: "api/banner",
  BANNER_CREATE: "api/banner",
  BANNER_UPDATE: "api/banner",
  BANNER_DELETE: "api/banner/:id",
  BANNER_DETAIL: "api/banner/:id",
  BANNER_TRANSLATE_CREATE: "/api/banner/translation",
  BANNER_TRANSLATE_UPDATE: "/api/banner/translation",
  BANNER_TRANSLATE_DELETE: "/api/banner/translation/:id",
  // Room type
  ROOM_TYPE_LIST: "/admin/roomtypes",
  ROOM_TYPE_LIST_BY_HOTEL_ID: "/admin/hotels/:id/roomtypes",
  ROOM_TYPE_CREATE: "/admin/roomtypes",
  ROOM_TYPE_DETAIL: "/admin/roomtypes",
  ROOM_TYPE_UPDATE: "/admin/roomtypes",
  ROOM_TYPE_TRANSLATE_CREATE: "/admin/roomtypes/translate",
  ROOM_TYPE_TRANSLATE_UPDATE: "/admin/roomtypes/translate",
  ROOM_TYPE_TRANSLATE_DELETE: "/admin/roomtypes/translate/:id",
  ROOM_TYPE_ALL_BY_HOTEL: "/Admin/hotels/:id/roomtypes/all",
  // Room type homestay
  HOMESTAY_ROOM_TYPE_LIST: "/admin/roomtypes",
  HOMESTAY_ROOM_TYPE_LIST_BY_HOTEL_ID: "/admin/property/:id/roomtypes",
  HOMESTAY_ROOM_TYPE_CREATE: "Admin/property/roomtypes",
  HOMESTAY_ROOM_TYPE_DETAIL: "/admin/property/roomtypes",
  HOMESTAY_ROOM_TYPE_UPDATE: "/admin/property/roomtypes",
  HOMESTAY_ROOM_TYPE_TRANSLATE_CREATE: "/Admin/property/roomtypes/translate",
  HOMESTAY_ROOM_TYPE_TRANSLATE_UPDATE: "/Admin/property/roomtypes/translate",
  HOMESTAY_ROOM_TYPE_TRANSLATE_DELETE:
    "/Admin/property/roomtypes/translate/:id",
  HOMESTAY_ROOM_TYPE_ALL_BY_HOTEL: "/Admin/property/:id/roomtypes/all",
  // Rate
  RATE_LIST: "/api/admin/hotel/:hotelId/rate-plan",
  RATE_LIST_EXCLUDED: "/api/admin/hotel/:hotelId/rate-plan/excluded",
  RATE_DESCRIPTION_TEMPLATE: "/api/admin/hotel/rate-plan/description-template",
  RATE_DESCRIPTION_IMPORT: "/api/admin/hotel/:hotelId/rate-plan/description/import",
  RATE_DETAIL: "/api/admin/hotel/rate-plan/:id",
  RATE_TRANSLATE_CREATE: "/api/admin/hotel/rate-plan/translate",
  RATE_TRANSLATE_UPDATE: "/api/admin/hotel/rate-plan/translate",
  RATE_TRANSLATE_DELETE: "/api/admin/hotel/rate-plan/translate/:id",
  RATE_SORT: "/api/admin/hotel/rate-plan/sort",
  RATE_SYNC_ALL_GOLF: "/api/admin/clubs/sync",
  RATE_SYNC_ALL: "api/admin/hotel/rate-plan/sync-all",
  RATE_SYNC: "api/admin/hotel/rate-plan/sync",
  RATE_LIST_BY_HOTELS: "/api/hotel/get-rate-plan",
  UPDATE_RATE_ACTIVE: "/api/admin/hotel/rate-plan/:id",
  UPDATE_RATE_EXTEND: "/api/admin/hotel/rate-plan/:id/status-extend",
  UPDATE_USAGE_STATUS: "/api/admin/hotel/rate-plan/usage-status",
  SYNC_RATE_LANGUAGE: "/api/admin/hotel/rate-plan/sync/language",
  RATE_AUTO_TRANSLATE: "api/admin/hotel/rate-plan/google-translate",
  // Rate Beach Villa
  CREATE_RATE_BEACH_VILLA: "/api/admin/hotel/beachvilla/:hotelId/rate-plan",
  GET_CONFIG_PRICE_BEACH_VILLA: "/admin/beachvilla/get-all-inventory",
  CREATE_CONFIG_PRICE_BEACH_VILLA: "/admin/beachvilla/create-inventory",
  UPDATE_CONFIG_PRICE_BEACH_VILLA: "/admin/beachvilla/update-inventory",
  // Rate Homestay
  HOMESTAY_RATE_LIST: "/admin/property/:homestayId/rate-plan",
  HOMESTAY_RATE_DETAIL: "/admin/property/rate-plan/:id",
  HOMESTAY_RATE_TRANSLATE_CREATE: "/Admin/property/rate-plan/translate",
  HOMESTAY_RATE_TRANSLATE_UPDATE: "/Admin/property/rate-plan/translate",
  HOMESTAY_RATE_TRANSLATE_DELETE: "/Admin/property/rate-plan/translate/:id",
  HOMESTAY_RATE_SORT: "/Admin/property/rate-plan/sort",
  HOMESTAY_RATE_SYNC_ALL: "/admin/property/rate-plan/sync-all",
  HOMESTAY_RATE_SYNC: "/admin/property/:id/rate-plan/sync",
  HOMESTAY_RATE_LIST_BY_HOMESTAY: "/admin/property/rate-plan/list",
  HOMESTAY_UPDATE_RATE_ACTIVE: "/admin/property/rate-plan/:id",
  HOMESTAY_UPDATE_RATE_EXTEND: "/admin/property/rate-plan/:id/status-extend",
  HOMESTAY_UPDATE_USAGE_STATUS: "/admin/property/rate-plan/usage-status",
  HOMESTAY_SYNC_RATE_LANGUAGE: "/admin/property/rate-plan/sync/language",
  HOMESTAY_RATE_AUTO_TRANSLATE: "/admin/property/rate-plan/google-translate",

  //cancel policy
  HOTEL_CANCEL_POLICY_UPDATE: "/api/admin/hotel/cancel-policy/:id",
  HOTEL_CANCEL_POLICY_SYNC: "/api/admin/hotel/cancel-policy/sync",

  //cancel policy homestay
  HOMESTAY_CANCEL_POLICY_UPDATE: "/admin/property/cancel-policy/:id",
  HOMESTAY_CANCEL_POLICY_SYNC: "/admin/property/cancel-policy/sync",

  // Bookable Package Rate
  BOOKABLE_PACKAGE_RATE_LIST:
    "/Admin/hotels/bookable-package-rate/:hotelId/search",
  BOOKABLE_PACKAGE_RATE_DETAIL: "/admin/hotels/bookable-package-rate/:id",
  BOOKABLE_PACKAGE_RATE_SORT: "/Admin/hotels/bookable-package-rate/sort",
  BOOKABLE_PACKAGE_RATE_SYNC_ALL:
    "/admin/hotels/bookable-package-rate/sync-all/:hotelId",
  BOOKABLE_PACKAGE_RATE_SYNC: "/admin/hotels/bookable-package-rate/sync/:id",
  BOOKABLE_PACKAGE_RATE_UPDATE: "/Admin/hotels/bookable-package-rate/:id",
  BOOKABLE_PACKAGE_RATE_ALL_LIST:
    "/Admin/hotels/bookable-package-rate/getlist/:hotelId",

  // Package Rate
  PACKAGE_RATE_LIST: "/api/PackageRate/all",
  PACKAGE_RATE_DETAIL: "/api/PackageRate/:id",
  PACKAGE_RATE_UPDATE_ACTIVE: "/api/PackageRate/update-status",
  PACKAGE_RATE_CLONE: "/api/PackageRate/copy",
  PACKAGE_RATE_UPDATE: "/api/PackageRate/:id",
  PACKAGE_RATE_CREATE: "/api/PackageRate/Create",
  PACKAGE_RATE_TRANSLATE: "/api/PackageRate/Translate",
  PACKAGE_RATE_TRANSLATE_DETAIL: "/api/PackageRate/Translate/:id",
  PACKAGE_RATE_PRODUCT_UPDATE: "api/packagerate/:id/product",
  PACKAGE_RATE_PRODUCT_DETAIL: "api/packagerate/product/:id",

  //Hotel
  HOTEL_LIST: "/admin/hotels",
  HOTEL_ALL: "/admin/hotels/all",
  HOTEL_ALL_ACTIVE: "/Admin/hotels/all",
  HOTEL_DETAIL: "/admin/hotels/:id",
  HOTEL_CREATE: "/admin/hotels",
  HOTEL_BOOKING_DETAIL: "/admin/booking/details",
  HOTEL_TRANSLATE_CREATE: "/admin/hotels/translate",
  HOTEL_TRANSLATE_UPDATE: "/admin/hotels/translate",
  HOTEL_TRANSLATE_DELETE: "/admin/hotels/translate/:id",
  HOTEL_RESET_CACHE: "/admin/reset-cache",
  HOTEL_COMPARE_RATE: "/admin/rate-compare-config",
  HOTEL_COMPARE_RATE_DETAIL: "/admin/rate-compare-config/:id",

  //Homestay
  HOMESTAY_LIST: "/admin/property",
  HOMESTAY_ALL: "/admin/property/all",
  HOMESTAY_ALL_ACTIVE: "/Admin/property/all",
  HOMESTAY_DETAIL: "/admin/property/:id",
  HOMESTAY_CREATE: "/admin/property",
  HOMESTAY_BOOKING_DETAIL: "/admin/booking/details",
  HOMESTAY_TRANSLATE_CREATE: "/admin/property/translate",
  HOMESTAY_TRANSLATE_UPDATE: "/admin/property/translate",
  HOMESTAY_TRANSLATE_DELETE: "/admin/property/translate/:id",
  HOMESTAY_RESET_CACHE: "/admin/reset-cache",
  HOMESTAY_COMPARE_RATE: "/admin/rate-compare-config",
  HOMESTAY_COMPARE_RATE_DETAIL: "/admin/rate-compare-config/:id",
  //CrossSell
  CROSSSELL_BOOKING_DETAIL: "/admin/booking/link-cross-sale/details",
  //Tag
  HOTEL_TAGGROUP_DETAIL_SKU: "/api/taggroupdetail/sku/:id",
  HOTEL_TAGGROUP_DETAIL_SKU_ACTIVE: "/api/taggroupdetail/sku/active-listing",
  //Provinces
  PROVINCE_LIST: "/stateprovince",
  // Google maps
  GOOGLE_MAPS_API: "https://maps.googleapis.com/maps/api",
  PLACE_DETAIL: "/place/details/json",
  // Locations
  LOCATION_LIST: "/admin/locations",
  LOCATION_SAVE: "/admin/locations",
  LOCATION_DETAIL: "/admin/locations",
  // Custom prices
  CUSTOM_PRICE_LIST: "/admin/prices",
  CUSTOM_PRICE_LIST_BY_HOTEL_ID: "/admin/hotels/:id/prices",
  CUSTOM_PRICE_DETAIL: "/admin/prices/:id",
  CUSTOM_PRICE_CREATE: "/admin/prices",
  // Popular place
  POPULAR_PLACE_LIST: "/admin/popularplaces",
  POPULAR_PLACE_DETAIL: "/admin/popularplaces/:id",
  POPULAR_PLACE_CREATE: "/admin/popularplaces",
  //Tour
  TOUR_LIST: "/admin/tour",
  TOUR_ALL: "/admin/tour/all",
  // export
  TOUR_EXPORT_EXCEL: "/admin/tour/exporttoexcel",
  TOUR_CLONE_EXCEL: "/admin/tour/clone",
  // TOUR_ALL_LIST: '/frontend/tour',
  TOUR_ALL_LIST: "/admin/tour/sale-order",
  TOUR_LINE_TICKET_LIST: "/frontend/tourlineitem/ticket",
  TOUR_DETAIL: "/admin/tour/:id",
  TOUR_CREATE: "/admin/tour",
  TOUR_DELETE: "/admin/tour/:id",
  TOUR_TYPE_ALL: "/admin/tourtype/all",
  TOUR_TYPE_DETAIL: "/admin/tourtype/:id",
  TOUR_TYPE_CREATE: "/admin/tourtype",
  TOUR_TYPE_DELETE: "/admin/tourtype/:id",
  TOUR_SURCHARGE_CATEGORIES: "/admin/surchargecategory",
  // TOUR_LINE_LIST_BY_TOUR_ID: '/admin/tourlineitem/tour/:tour_id',
  TOUR_LINE_LIST_BY_TOUR_ID_ADMIN: "/admin/tourlineitem/tour/:tour_id",
  TOUR_LINE_LIST_BY_TOUR_ID: "/frontend/tourlineitem/tour/:tour_id",
  TOUR_LINE_DETAIL: "/admin/tourlineitem/:id",
  TOUR_LINE_CREATE: "/admin/tourlineitem",
  TOUR_LINE_BULK_CREATE: "/admin/tourlineitem/bulk",
  TOUR_LINE_BULK_DELETE: "/admin/tourlineitem/bulk",
  TOUR_TRANSLATE_CREATE: "/admin/tour/translate",
  TOUR_TRANSLATE_UPDATE: "/admin/tour/translate",
  TOUR_TRANSLATE_DELETE: "/admin/tour/translate/:id",
  TOUR_LINE_SALE_HISTORY: "/admin/tourlineitem/salehistory",
  DETAIL_TOUR_TICKET_LIST: "/admin/tourticket",
  DETAIL_TOUR_TICKET_DETAIL: "/admin/tourticket/:id",
  DETAIL_TOUR_TICKET_CREATE: "/admin/tourticket",
  DETAIL_TOUR_TICKET_DELETE: "/admin/tourticket/:id",
  DETAIL_TOUR_TICKET_TRANSLATE_CREATE: "/admin/tourticket/translation",
  DETAIL_TOUR_TICKET_TRANSLATE_UPDATE: "/admin/tourticket/translation",
  DETAIL_TOUR_TICKET_TRANSLATE_DELETE: "/admin/tourticket/translation/:id",

  TOUR_ITEM_TICKETS: "/admin/tourlineitem/:tourlineId/ticket",
  TOUR_ITEM_TICKET_GET_DETAIL: "/admin/tourlineitem/ticket",
  TOUR_ITEM_TICKET_DETAIL_ACTION: "/admin/tourlineitem/ticket",
  TOUR_ITEM_TICKET_DETAIL_DELETE: "/admin/tourlineitem/ticket/:id",
  //Tour
  TOUR_TICKET_LIST: "/admin/ticket",
  TOUR_TICKET_LIST_ALL: "/admin/ticket/all",
  TOUR_TICKET_DETAIL: "/admin/ticket/:id",
  TOUR_TICKET_CREATE: "/admin/ticket",
  TOUR_TICKET_DELETE: "/admin/ticket/:id",
  TOUR_TICKET_TRANSLATE_CREATE: "/admin/ticket/translate",
  TOUR_TICKET_TRANSLATE_UPDATE: "/admin/ticket/translate",
  TOUR_TICKET_TRANSLATE_DELETE: "/admin/ticket/translate/:id",
  //Tour Ticket
  TOUR_TICKET_LIST_ALL_BY_ID: "/admin/tourticket/tour/:id",
  //Supplier
  SUPPLIER_LIST: "/admin/supplier",
  SUPPLIER_LIST_ALL: "/admin/supplier/all",
  SUPPLIER_SELECT_LIST: "/admin/supplier/list",
  SUPPLIER_DETAIL: "/admin/supplier/:id",
  SUPPLIER_CREATE: "/admin/supplier",
  SUPPLIER_UPDATE: "/admin/supplier",
  SUPPLIER_DELETE: "/admin/supplier/:id",
  SUPPLIER_PRODUCT_CODE: "/admin/supplierproduct/code/:id",
  SUPPLIER_DETAIL_FAQS: "/admin/supplier/faqs/:id",
  SUPPLIER_CREATE_FAQS: "/admin/supplier/faqs",
  SUPPLIER_DELETE_FAQS: "/admin/supplier/faqs/:id",
  SUPPLIER_PRODUCT_LIST: "/admin/supplierproduct",
  SUPPLIER_PRODUCT_ALL: "/admin/supplierproduct/all",
  SUPPLIER_PRODUCT_DETAIL: "/admin/supplierproduct/:id",
  SUPPLIER_PRODUCT_CREATE: "/admin/supplierproduct",
  SUPPLIER_PRODUCT_UPDATE: "/admin/supplierproduct",
  SUPPLIER_PRODUCT_DELETE: "/admin/supplierproduct",
  SUPPLIER_PRODUCT_GENERATE: "admin/supplierproduct/generate-code/:id",
  SUPPLIER_PRODUCT_SEARCH_CODE: "/admin/supplierproduct/auto-complete/:id",
  SUPPLIER_PRODUCT_GET_SALE_PLAN_MODE:
    "/admin/supplierproduct/get-sale-plan-mode/:id",
  SUPPLIER_PRODUCT_USAGE_PLAN: "/admin/supplierproduct/product-usage-plan/:id",
  SUPPLIER_VINWONDER_SITES: "/admin/supplier/vinwonder-sites",
  SUPPLIER_VINWONDER_TYPES: "/admin/supplier/vinwonder-types",
  SUPPLIER_VINWONDER_REFIDS: "/admin/supplierproduct/vinwonder-tickets",
  SUPPLIER_TRANSLATE_CREATE: "/admin/supplier/translate",
  SUPPLIER_TRANSLATE_UPDATE: "/admin/supplier/translate",
  SUPPLIER_TRANSLATE_DELETE: "/admin/supplier/translate/:id",
  NAPAS_RECON_EMAIL_CONFIG: "/api/v1/napas-recon-email-config",
  //ratecode
  RATECODE_LIST_ALL: "/admin/ratecode/all",
  RATECODE_LIST_WITH_PAGING: "/admin/ratecode/with-paging",
  RATECODE_LIST: "/admin/ratecode",
  RATECODE_DETAIL: "/admin/ratecode/:id",
  RATECODE_SCHEDULE: "/admin/ratecode/schedule/:id",
  RATECODE_INVENTORY: "/admin/ratecode/inventorydelivery",
  RATECODE_SCHEDULE_CREATE: "/admin/ratecode/schedule",
  RATECODE_CREATE: "/admin/ratecode",
  RATECODE_UPDATE: "/admin/ratecode/:id",
  RATECODE_DELETE: "/admin/ratecode/:id",
  RATECODE_CAMPAIGN_LIST: "/admin/ratecode/campaign",
  RATECODE_CAMPAIGN_CREATE: "/admin/ratecode/campaign",
  RATECODE_LOCK: "/admin/ratecode/lock/:id",
  RATECODE_SYNC_SLOT_SERVICES: "/admin/ratecode/:id/sync-slot-services",
  //supplier category
  SUPPLIER_CATEGORY_LIST_ALL: "/admin/category/all",
  SUPPLIER_CATEGORY_LIST: "/admin/category",
  SUPPLIER_CATEGORY_DETAIL: "/admin/category/:id",
  SUPPLIER_CATEGORY_CREATE: "/admin/category",
  SUPPLIER_CATEGORY_UPDATE: "/admin/category/:id",
  SUPPLIER_CATEGORY_DELETE: "/admin/category/:id",
  //Category
  CATEGORY_LIST: "/api/category",
  CATEGORY_LIST_ALL: "/api/category/all",
  CATEGORY_DETAIL: "/api/category/:id",
  CATEGORY_ACTION: "/api/category",
  CATEGORY_CREATE: "/api/category",
  CATEGORY_TRANSLATE_CREATE: "/api/category/translation",
  CATEGORY_TRANSLATE_UPDATE: "/api/category/translation",
  CATEGORY_TRANSLATE_DELETE: "/api/category/translation/:id",
  // Pages
  PAGE_LIST: "/api/page",
  PAGE_DETAIL: "/api/page/:id",
  PAGE_ACTION: "/api/page",
  PAGE_TRANSLATE_CREATE: "/api/page/translation",
  PAGE_TRANSLATE_UPDATE: "/api/page/translation",
  PAGE_TRANSLATE_DELETE: "/api/page/translation/:id",
  //Post
  POST_LIST: "/api/post",
  POST_DETAIL: "/api/post/:id",
  POST_ACTION: "/api/post",
  POST_TRANSLATE_CREATE: "/api/post/translation",
  POST_TRANSLATE_UPDATE: "/api/post/translation",
  POST_TRANSLATE_DELETE: "/api/post/translation/:id",
  //Rating
  RATING_LIST: "/api/rating",
  RATING_APPROVE: "/api/rating/approve",
  RATING_DELETE: "/api/rating",
  RATING_REPLY_APPROVE: "/api/rating/reply/approve",
  RATING_REPLY_DELETE: "/api/rating/reply",
  //Order
  ORDER_LIST: "/api/order",
  ORDER_DETAIL: "/api/order/:id",
  ORDER_UPDATE: "/api/order",
  ORDER_FLIGHT_UPDATE: "/api/admin/order",
  ORDER_UPDATE_INVOICE: "/api/order/invoice",
  ORDER_DETAIL_ITEM: "/api/order/:id/orderitem",
  ORDER_DETAIL_ITEM_VOUCHER: "/api/voucher/salehistory",
  ORDER_DETAIL_ITEM_FLIGHT: "/api/order/:id",
  ORDER_RESEND_EMAIL: "/api/order/:id/resendemail",
  ORDER_SEND_EMAIL_TEMPLATE: "/api/order/:id/sendemail/:email_id",
  ORDER_EXPORT_EXCEL: "/api/order/exporttoexcel",
  ORDER_EXPORT_SKU_EXCEL: "/api/report/exportorderreportbysku",
  ORDER_EXPORT_SKU_SALE_DETAIL_EXCEL: "/api/report/exportorderreportbysku",
  ORDER_EXPORT_HOTEL_SALE_DETAIL_EXCEL: "/api/report/exportorderreporthotel",
  ORDER_EXPORT_ACCESS_TRADE: "/api/order/exportaccesstrade",
  ORDER_AFFILIATE_SOURCES: "/api/Order/affiliate-sources",
  ORDER_EXPORT_SALE_ORDER: "/api/order/saleorder",
  ORDER_EXPORT_TOUR_SALE_ORDER: "/api/order/saleordertour",
  ORDER_EXPORT_VOUCHER: "/api/order/:id/exportvoucher",
  ORDER_ITEM_CHANGE_STATUS: "/api/order/orderitemstatus",
  ORDER_ITEM_LOCK: "/api/order/lockorderitem",
  ORDER_TOUR_RECOMMIT: "/api/order/:id/recommit",
  ORDER_RETRY_CIAPS_BOOKING: "/api/Order/:id/RetryCiapsBooking",
  ORDER_CHANGE_STATUS: "/api/order/orderstatus",
  ORDER_CHANGE_RATE_CODE: "/api/order/changeRateCodeOrderItem",
  ORDER_RECOMMIT_HOTEL_BUNDLE: "/api/order/recommithotelbundle",
  ORDER_PUSH_FIXED_CHARGE: "/api/order/recommit-fixcharge",
  VINWONDER_CUSTOMERS_LIST: "/bwc/vinwonder/vinwondercustomers/:orderId",
  SMS_HISTORIES_LIST: "/api/order/:orderId/sms-histories",
  SMS_RESEND: "/api/order/:orderId/resend-sms/:id",
  ORDER_EXCHARGE: "/api/order/:orderId/fixcharge",
  ORDER_EXCHARGE_RESEND: "/api/order/recommit-fixcharge",
  ORDER_REPUSH_AFFILIATE: "/api/order/affiliate",
  ORDER_ACCOUNTANT: "/api/order/accountant/:orderId/:accountantStatus",
  ORDER_DETAIL_GOLF: "/api/orders/:vptOrderId ",
  // Transportation
  AIRLINE_ALL: "/api/airline",
  GET_TRANSPORTATIONS: "/api/transportation/:propertyId/task",
  AIRPORT_ALL: "/api/airport/domestic",
  GET_ROUTES: "api/transportation/:propertyId/routes",
  GET_VEHICLE_TYPES:
    "api/transportation/:propertyId/routes/:routeId/vehicle-types",
  GET_VEHICLE: "api/transportation/:propertyId/vehicles/:vehicleTypeId",

  // Surcharge
  ORDER_SURCHARGE_ITEMS: "/api/surcharge",
  ORDER_SURCHARGE_GET_DETAIL: "/api/surcharge/:id",
  ORDER_SURCHARGE_DETAIL_DELETE: "/api/surcharge/:id/:ftCode",
  ORDER_SURCHARGE_DETAIL_ACTION: "/api/surcharge",
  ORDER_SURCHARGE_CHECK_STOCK_ACTION: "/api/surcharge/checkstock",

  //Email Template
  EMAIL_TEMPLATE_LIST: "/api/email",
  EMAIL_TEMPLATE_DETAIL: "/api/email/:id",
  EMAIL_TEMPLATE_ACTION: "/api/email",
  EMAIL_TEMPLATE_TRANSLATE_CREATE: "/api/email/translation",
  EMAIL_TEMPLATE_TRANSLATE_UPDATE: "/api/email/translation",
  EMAIL_TEMPLATE_TRANSLATE_DELETE: "/api/email/translation/:id",
  // TICKET
  TICKET_LIST: "/api/ticket",
  TICKET_DETAIL: "/api/ticket/:id",
  TICKET_UPDATE: "/api/ticket",
  TICKET_MY_LIST: "/api/ticket/myticket",
  TICKET_MY_DETAIL: "/api/ticket/myticket/:id",
  TICKET_MY_UPDATE: "/api/ticket/myticket",
  TICKET_ASSIGN_CONFIG_LIST: "/api/ticketassignconfig",
  TICKET_ASSIGN_CONFIG_DETAIL: "/api/ticketassignconfig/:id",
  TICKET_ASSIGN_CONFIG_CREATE: "/api/ticketassignconfig",
  TICKET_ASSIGN_CONFIG_UPDATE: "/api/ticketassignconfig",
  TICKET_ASSIGN_CONFIG_DELETE: "/api/ticketassignconfig",
  //Product
  PRODUCT_LIST: "/api/voucherproduct",
  PRODUCT_LIST_ALL: "/api/voucherproduct/all",
  PRODUCT_CREATE: "/api/voucherproduct",
  PRODUCT_UPDATE: "/api/voucherproduct",
  PRODUCT_DETAIL: "/api/voucherproduct/:id",
  PRODUCT_DELETE: "/api/voucherproduct/:id",
  PRODUCT_TRANSLATE_CREATE: "/api/voucherproduct/translation",
  PRODUCT_TRANSLATE_UPDATE: "/api/voucherproduct/translation",
  PRODUCT_TRANSLATE_DELETE: "/api/voucherproduct/translation/:id",
  //Property
  PROPERTY_LIST: "/api/property",
  PROPERTY_LIST_ALL: "/api/property/all",
  PROPERTY_TOUR_LIST_ALL: "/admin/property/all",
  PROPERTY_CREATE: "/api/property",
  PROPERTY_UPDATE: "/api/property",
  PROPERTY_DETAIL: "/api/property/:id",
  PROPERTY_DELETE: "/api/property/:id",
  PROPERTY_TRANSLATE_CREATE: "/api/property/translation",
  PROPERTY_TRANSLATE_UPDATE: "/api/property/translation",
  PROPERTY_TRANSLATE_DELETE: "/api/property/translation/:id",
  //Group
  GROUP_LIST: "/api/group",
  GROUP_LIST_ALL: "/api/group/all",
  GROUP_CREATE: "/api/group",
  GROUP_UPDATE: "/api/group",
  GROUP_DETAIL: "/api/group/:id",
  GROUP_DELETE: "/api/group/:id",
  GROUP_CLONE: "/api/group/clone",
  GROUP_IMPORT: "/api/group/importgroup",
  GROUP_EXPORT_EXCEL: "/api/group/exporttoexcel",
  GROUP_TRANSLATE_CREATE: "/api/group/translation",
  GROUP_TRANSLATE_UPDATE: "/api/group/translation",
  GROUP_TRANSLATE_DELETE: "/api/group/translation/:id",
  GROUP_EXPORT_PRODUCT_FEED: "/api/group/exportproductfeed",
  GROUP_REINDEX_PRODUCT: "/api/experience/reindex",
  //Group Categories
  GROUP_CATEGORY_LIST: "/api/category",
  GROUP_CATEGORY_LIST_ALL: "/api/category/all",
  GROUP_CATEGORY_CREATE: "/api/category",
  GROUP_CATEGORY_UPDATE: "/api/category",
  GROUP_CATEGORY_DETAIL: "/api/category/:id",
  GROUP_CATEGORY_DELETE: "/api/category/:id",
  GROUP_CATEGORY_TRANSLATE_CREATE: "/api/category/translation",
  GROUP_CATEGORY_TRANSLATE_UPDATE: "/api/category/translation",
  GROUP_CATEGORY_TRANSLATE_DELETE: "/api/category/translation/:id",
  //Voucher
  VOUCHER_LIST: "/api/voucher",
  VOUCHER_CHECK: "/api/voucher/check",
  VOUCHER_REDEEM: "/api/voucher/redeem",
  VOUCHER_EXPORT_EXCEL: "/api/voucher/exporttoexcel",
  VOUCHER_IMPORT: "/api/voucher/importvoucher",
  VOUCHER_CREATE: "/api/voucher",
  VOUCHER_DETAIL: "/api/voucher/:id",
  VOUCHER_UPDATE: "/api/voucher",
  VOUCHER_DETAIL_HISTORY: "/api/voucher/:id/history",
  VOUCHER_EXCHANGE_RATE_LIST: "/api/exchangerate",
  VOUCHER_EXCHANGE_RATE_UPDATE: "/api/exchangerate",
  //Flight
  FLIGHT_CONFIG: "/api/flight/config",
  FLIGHT_TRACKING: "/api/flight/tracking",
  FLIGHT_TRACKING_ORDER: "/api/flight/tracking/order/:orderId",
  FLIGHT_TRACKING_DETAIL: "/api/flight/tracking/:id",
  //Upload
  UPLOAD_STORAGE: "/api/cms/storage",
  // Create union bank
  CREATE_UNION_BANK: "/api/payment/bank",
  // REPORT
  SALE_REPORT: "/api/report/salereport",
  SALE_REPORT_BY_ORDER: "/api/report/salereportbyorder",
  SALE_REPORT_BY_SKU: "/api/report/orderreportbysku",
  SALE_DETAIL_REPORT_BY_SKU: "/api/report/reportbysku",
  REPORT_VOUCHER_REDEEMTION: "/api/report/redemptionreport",
  REPORT_VOUCHER_REDEEMTION_DETAIL: "/api/report/redemptionreportdetail",
  REPORT_EXPORT_VOUCHER_REDEEMTIONS: "/api/report/exportredemptionreport",
  REPORT_CASH_FLOW: "/api/CashFlow",
  REPORT_COLLABORATOR: "/api/order/list-order-accumulation",
  CROSS_CHECK_PMS: "/api/order/Crosscheck-PMS",
  EXPORT_COLLABORATOR_REPORT: "/api/order/export-report-collaborator",
  SALE_DETAIL_REPORT_BY_HOTEL: "/api/report/report-hotel",
  BUNDLE_REPORT: "/api/report/report-bundle",
  EXPORT_BUNDLE_REPORT_EXCEL: "/api/report/exportorderreportbundle",
  EXPORT_BTB_ORDER_REPORT: "/api/report/export-beach-villa-reservation",
  REPORT_BTB_ORDER: "/api/report/report-beach-villa-reservation",
  EXPORT_BTB_USE_ROOM_REPORT: "/api/report/export-beach-villa-inventory",
  REPORT_BTB_USE_ROOM: "/api/report/report-beach-villa-inventory",
  //Recommendation
  RECOMMENDATION: "/admin/recommendation",

  //Cash Flow
  CASH_FLOW_TRANSACTIONS: "/api/cashflow/transaction-filter",
  CASH_FLOW_ACCOUNTS: "/api/cashflow/get-account",
  CASH_FLOW_TRANSACTION_IMBALANCE: "/api/cashflow/transaction-imbalance",
  CASH_FLOW_RECEIPTS_PAYSLIP_CREATE: "/api/cashflow/receipts-pay-slip",

  //Site Info
  SITEINFO_LIST: "/api/siteinfo",
  SITEINFO_DETAIL: "/api/siteinfo/:id",
  SITEINFO_ACTION: "/api/siteinfo",
  SITEINFO_CREATE: "/api/siteinfo",
  SITEINFO_TRANSLATE_CREATE: "/api/siteinfo/translation",
  SITEINFO_TRANSLATE_UPDATE: "/api/siteinfo/translation",
  SITEINFO_TRANSLATE_DELETE: "/api/siteinfo/translation/:id",

  //Redirect Link
  REDIRECT_LINK_LIST: "/api/admin/redirectlink/get-all",
  REDIRECT_LINK_DETAIL: "/api/admin/redirectlink/:id",
  REDIRECT_LINK_ACTION: "/api/admin/redirectlink",
  REDIRECT_LINK_CREATE: "/api/admin/redirectlink",

  //Config PHS
  CONFIG_PHS_INFO: "/admin/phs",
  CONFIG_PHS_ACTION: "/admin/phs",

  // Object Type
  OBJECT_TYPE_LIST: "/admin/objecttype",
  OBJECT_TYPE_ALL: "/admin/objecttype/all",
  OBJECT_TYPE_DETAIL: "/admin/objecttype/:id",
  OBJECT_TYPE_ACTION: "/admin/objecttype",
  OBJECT_TYPE_CREATE: "/admin/objecttype",
  OBJECT_TYPE_TRANSLATE_CREATE: "/admin/objecttype/translation",
  OBJECT_TYPE_TRANSLATE_UPDATE: "/admin/objecttype/translation",
  OBJECT_TYPE_TRANSLATE_DELETE: "/admin/objecttype/translation/:id",

  // Promotion
  PROMOTION_LIST: "/api/admin/promotion",
  PROMOTION_UPDATE_STATUS: "/api/admin/promotion/update-status",
  PROMOTION_CAMPAIGN_LIST: "/api/admin/promotion/campaign",
  PROMOTION_CAMPAIGN_LIST_ALL: "/api/admin/campaign/all",
  PROMOTION_BUNDLE_LIST: "/api/admin/promotion/bundle",
  PROMOTION_EXPORT_FILE: "/api/admin/promotion/export",
  PROMOTION_ACTIVE_DEACTIVATED_CODE: "api/promotion/active-code",
  PROMOTION_CHECK_CODE: "/api/admin/promotion/check/:code",
  PROMOTION_HISTORY_CODE: "/api/admin/promotion/history",
  CAMPAIGN_LIST: "/api/admin/campaign",
  CAMPAIGN_DETAIL: "/api/admin/campaign/:id",
  CAMPAIGN_CREATE: "/api/admin/campaign",
  CAMPAIGN_UPDATE: "/api/admin/campaign",
  CAMPAIGN_CLONE: "/api/admin/campaign/clone",
  CAMPAIGN_TRANSLATE_CREATE: "/api/admin/campaign/translate",
  CAMPAIGN_TRANSLATE_UPDATE: "/api/admin/campaign/translate",
  // CAMPAIGN_TRANSLATE_DELETE: '/api/admin/campaign/translate/:id',
  CAMPAIGN_COUNTRIES_LIST: "/api/admin/campaign/get-all-countries",
  CAMPAIGN_CHANNELS_LIST: "/api/admin/campaign/get-all-channel",
  CAMPAIGN_PARSE_EXCEL: "/api/admin/campaign/parseExcel",
  BUNDLE_PARSE_EXCEL: "/api/admin/bundle/parseExcel",
  //markup
  CAMPAIGN_MARKUP_CONFIG: "/api/markupbundle/markup-config",
  CAMPAIGN_MARKUP_FLY: "/api/admin/airline/domestic",
  CAMPAIGN_MARKUP_BUNDLE_MIN_VALUE: "/api/admin/airline/domestic",

  AUTOFILL_LIST: "/api/admin/promotion/autofill",
  AUTOFILL_CREATE: "/api/admin/promotion/autofill",
  AUTOFILL_DETAIL: "/api/admin/promotion/autofill/:id",
  AUTOFILL_UPDATE: "/api/admin/promotion/autofill",

  PROMOTION_STATUS_EXCEL: "/api/admin/promotion/de-active/import",
  PROMOTION_UPDATE_STATUS_GROUP: "/api/admin/promotion/de-active",
  PROMOTION_GET_FILE_SAMPLE: "/api/markupbundle/min-value",

  // AMENITY
  AMENITY_LIST: "/api/admin/amenity",
  AMENITY_DETAIL: "/api/admin/amenity/:id",
  AMENITY_ACTION: "/api/admin/amenity",
  AMENITY_CREATE: "/api/admin/amenity",
  AMENITY_TRANSLATE_CREATE: "/api/admin/amenity/translate",
  AMENITY_TRANSLATE_UPDATE: "/api/admin/amenity/translate",
  AMENITY_TRANSLATE_DELETE: "/api/admin/amenity/translate/:id",

  AMENITY_AVAILABILITY: "/availability/amenity/all",

  //Agent
  AGENT_LIST: "/api/agent",
  AGENT_ALL_LIST: "/api/agent/all",
  AGENT_DETAIL: "/api/agent/:id",
  AGENT_ACTION: "/api/agent",
  AGENT_CREATE: "/api/agent",
  AGENT_LIST_REPORTS: "/api/agent/agentreport",

  // Promotion
  COUPON_GET: "/api/promotion/check-code",

  //Airport
  AIRPORT_LIST: "/api/admin/airport",
  AIRPORT_DETAIL: "/api/admin/airport/:id",
  AIRPORT_ACTION: "/api/admin/airport",
  AIRPORT_CREATE: "/api/admin/airport",
  AIRPORT_TRANSLATE_CREATE: "/api/admin/airport/translation",
  AIRPORT_TRANSLATE_UPDATE: "/api/admin/airport/translation",
  AIRPORT_TRANSLATE_DELETE: "/api/admin/airport/translation/:id",
  AIRPORT_LIST_DEPARTURE: "/api/airport/search/departure",
  AIRPORT_LIST_ARRIVAL: "/api/airport/search/arrival",
  AIRLINE_LIST_DOMESTIC: "/api/admin/airline/domestic",
  TOAIRPORT_LIST: "/api/admin/airport/segments/:id",
  AIRLINE_SOURCE_VJ: "/api/admin/airlinesource/VJ",
  AIRLINE_SOURCE_UPDATE: "/api/admin/airlinesource",

  //Golf
  GOLF_LIST: "/api/admin/clubs",
  GOLF_DETAIL: "/api/admin/:id",
  GOLF_DETAIL_UPDATE: "/api/admin/clubs/:id",
  GOLF_UPDATE_ORDER: "/api/admin/clubs/re-order",
  GOLF_TRANSLATE_CREATE: "/api/admin/clubs/translate",
  GOLF_TRANSLATE_UPDATE: "/api/admin/clubs/translate/:id",
  GOLF_TRANSLATE_DELETE: "/api/admin/clubs/translate/:id",

  //Fare Rule
  FARE_RULE_LIST: "/api/admin/farerule",
  FARE_RULE_DETAIL: "/api/admin/farerule/:id",
  FARE_RULE_ACTION: "/api/admin/farerule",
  FARE_RULE_CREATE: "/api/admin/farerule",
  FARE_RULE_TRANSLATE_CREATE: "/api/admin/farerule/translation",
  FARE_RULE_TRANSLATE_UPDATE: "/api/admin/farerule/translation",
  FARE_RULE_TRANSLATE_DELETE: "/api/admin/farerule/translation/:id",

  //Baggage
  BAGGAGE_LIST: "/api/admin/baggage",
  BAGGAGE_DETAIL: "/api/admin/baggage/:id",
  BAGGAGE_ACTION: "/api/admin/baggage/:id",
  BAGGAGE_CREATE: "/api/admin/baggage",

  // VinWonder
  VIN_WONDER_LIST: "/api/vinwonder",
  VIN_WONDER_ALL: "/api/vinwonder/all",
  VIN_WONDER_CREATE: "/api/vinwonder",
  VIN_WONDER_CHECK: "/api/vinwonder/check/:serialNumber",
  VIN_WONDER_UPDATE: "/api/vinwonder",
  VIN_WONDER_DETAIL: "/api/vinwonder/:id",
  VIN_WONDER_DELETE: "/api/vinwonder/:id",
  VIN_WONDER_TRANSLATE_CREATE: "/api/vinwonder/translation",
  VIN_WONDER_TRANSLATE_UPDATE: "/api/vinwonder/translation",
  VIN_WONDER_TRANSLATE_DELETE: "/api/vinwonder/translation/:id",
  VIN_WONDER_SITES: "/api/vinwonder/sites",
  VIN_WONDER_TYPES: "/api/vinwonder/type",
  VIN_WONDER_SESSIONS: "/frontend/tourlineitem/vinwonder-session",
  VIN_WONDER_ZONES: "/frontend/tourlineitem/vinwonder-zone",

  // VinWonder TickeT
  VIN_WONDER_TICKET_LIST: "/api/vinwonderticket",
  VIN_WONDER_TICKET_CREATE: "/api/vinwonderticket",
  VIN_WONDER_TICKET_UPDATE: "/api/vinwonderticket",
  VIN_WONDER_TICKET_DETAIL: "/api/vinwonderticket/:id",
  VIN_WONDER_TICKET_DELETE: "/api/vinwonderticket/:id",
  VIN_WONDER_TICKET_TRANSLATE_CREATE: "/api/vinwonderticket/translation",
  VIN_WONDER_TICKET_TRANSLATE_UPDATE: "/api/vinwonderticket/translation",
  VIN_WONDER_TICKET_TRANSLATE_DELETE: "/api/vinwonderticket/translation/:id",

  GET_LIST_REF: "/api/vinwonderticket/vpl/",
  VIN_WONDER_TICKET_ITEM_LIST: "/api/vinwonderticket/item",
  VIN_WONDER_TICKET_ITEM_CREATE: "/api/vinwonderticket/item",
  VIN_WONDER_TICKET_ITEM_UPDATE: "/api/vinwonderticket/item",
  VIN_WONDER_TICKET_ITEM_DETAIL: "/api/vinwonderticket/item/:id",
  VIN_WONDER_TICKET_ITEM_DELETE: "/api/vinwonderticket/item/:id",

  // Custom prices
  VIN_WONDER_PRICE_LIST: "/api/vinwonder/prices",
  VIN_WONDER_PRICE_DETAIL: "/api/vinwonder/prices/:id",
  VIN_WONDER_PRICE_CREATE: "/api/vinwonder/prices",
  VIN_WONDER_PRICE_UPDATE: "/api/vinwonder/prices",
  VIN_WONDER_PRICE_DELETE: "/api/vinwonder/prices/:id",

  // TAG GROUP
  TAG_GROUP_ALL: "/api/taggroup/all",
  TAG_GROUP_DETAIL_LIST: "/api/taggroupdetail",
  TAG_GROUP_DETAIL_ALL: "/api/taggroupdetail/all",
  TAG_GROUP_DETAIL_ITEM: "/api/taggroupdetail/:id",
  TAG_GROUP_DETAIL_CREATE: "/api/taggroupdetail",
  TAG_GROUP_DETAIL_UPDATE: "/api/taggroupdetail",
  TAG_GROUP_DETAIL_DELETE: "/api/taggroupdetail/:id",
  TAG_GROUP_DETAIL_MAP_SKU: "/api/taggroupdetail/mapsku",
  TAG_GROUP_DETAIL_TRANSLATE_CREATE: "/api/taggroupdetail/translation",
  TAG_GROUP_DETAIL_TRANSLATE_UPDATE: "/api/taggroupdetail/translation",
  TAG_GROUP_DETAIL_TRANSLATE_DELETE: "/api/taggroupdetail/translation/:id",
  TAG_IN_TAG_GROUP: "/api/taggroupdetail",
  TAG_BY_SKU: "/api/taggroup/get-tag-group-by-sku/:id",
  TAG_GROUP_SKU_MAPPING_UPDATE: "/api/taggroupdetail/sku-mapping-tag",
  TAGS_BY_GROUP: "/api/taggroupdetail/GetbytagGroups",

  //Property
  TOUR_PROPERTY_LIST: "/admin/property",
  TOUR_PROPERTY_LIST_ALL: "/admin/property/all",
  TOUR_PROPERTY_CREATE: "/admin/property",
  TOUR_PROPERTY_UPDATE: "/admin/property",
  TOUR_PROPERTY_DETAIL: "/admin/property/:id",
  TOUR_PROPERTY_DELETE: "/admin/property/:id",
  TOUR_PROPERTY_TRANSLATE_CREATE: "/admin/property/translation",
  TOUR_PROPERTY_TRANSLATE_UPDATE: "/admin/property/translation",
  TOUR_PROPERTY_TRANSLATE_DELETE: "/admin/property/translation/:id",
  TOUR_CHECK_REDEEM: "/admin/tour/checkvoucher",
  TOUR_SYNC_DATE_ITI_NUMBER: "/admin/tour/syncDateByItiNumber/:id",
  TOUR_REDEEM: "/admin/tour/redeem",

  // Bundles
  BUNDLE_LIST: "/api/admin/bundle",
  BUNDLE_CREATE: "/api/admin/bundle",
  BUNDLE_DETAIL: "/api/admin/bundle/:id",
  BUNDLE_UPDATE: "/api/admin/bundle/:id",

  // Ticket Sold
  TICKET_SOLD_LIST: "/admin/tourticket/ticketsold",

  // Pay at hotel
  PAY_AT_HOTEL_DETAIL: "/admin/hotels/payathotel",
  PAY_AT_HOTEL_UPDATE: "/admin/hotels/payathotel",
  PROFILE_TYPE_LIST: "/admin/hotels/profiletypes",

  //Make up Bundle
  MARKUP_BUNDLE_LIST: "/api/MarkupBundle/all",
  MARKUP_BUNDLE_ALL_LIST: "/api/MarkupBundle/all",
  MARKUP_BUNDLE_DETAIL: "/api/MarkupBundle/:id",
  MARKUP_BUNDLE_ACTION: "/api/MarkupBundle",
  MARKUP_BUNDLE_CREATE: "/api/MarkupBundle",

  //Payment
  PROMOTION_BANK_LIST: "api/admin/campaign/promotion-banks",
  //WarehouseManagement
  GET_WAREHOUSE_GOOD_RECEIPT_CODE:
    "/admin/WarehouseManagement/good-receipt-code",
  GET_LIST_WAREHOUSE_GOOD_RECEIPT: "/admin/WarehouseManagement/good-receipts",
  CREATE_WAREHOUSE_GOOD_RECEIPT: "/admin/WarehouseManagement/good-receipt",
  GET_WAREHOUSE_GOOD_RECEIPT: "/admin/WarehouseManagement/good-receipt/:id",
  GET_RATE_CODE_USAGE_PLAN_WAREHOUSE_GOOD_RECEIPT:
    "admin/WarehouseManagement/stock/rate-codes",
  GET_STOCK_PRODUCTS_WAREHOUSE_GOOD_RECEIPT:
    "admin/WarehouseManagement/stock/codes",
  //Credit Point
  GET_LIST_REFUND_HISTORIES: "api/creditpoint/refund-histories",
  CONFIRM_REFUND_HISTORIES: "api/creditpoint/refund-confirmation",
  CANCEL_REFUND_HISTORIES: "api/creditpoint/refund-cancelation",
  //Profile
  UPDATE_ORDER_PROFILE: "api/order/order-profile",
  // AppUI
  GET_LIST_APP_UI: "api/AppUIConfigurations",
  GET_WHITELIST_IP: "api/admin/IpAddress",
  CREATE_NEW_APP_UI: "api/AppUIConfigurations",
  GET_DETAIL_APP_UI: "api/AppUIConfigurations/:id",
  UPDATE_APP_UI: "api/AppUIConfigurations",
  DELETE_APP_UI: "api/AppUIConfigurations/:id",
  DELETE_IP: "api/admin/IpAddress/:id",
  CREATE_IP: "api/admin/IpAddress",
  APP_UI_TRANSLATE: "api/AppUIConfigurations/translation",
  DELETE_APP_UI_TRANSLATE: "api/AppUIConfigurations/translation/:id",
  GET_POINT_HISTORIES: "/api/order/:id/point-histories",
  REFUND_ORDER_POINT: "/api/order/refund/:id",

  VINWONDER_SKU_TAGS_LIST: "/api/taggroupdetail/getvinwonderskutags",
  VINWONDER_SKU_TAGS_CREATE: "/api/taggroupdetail/addvinwonderskutag",
  VINWONDER_SKU_TAGS_EDIT: "/api/taggroupdetail/updatevinwonderskutag",
  VINWONDER_SKU_TAGS_DELETE: "/api/taggroupdetail",

  // VinWonder Tag Group
  VIN_WONDER_TAGGROUP_LIST: "/api/vinwondertaggroup",
  VIN_WONDER_TAGGROUP_SUPPLIER_LIST: "/api/vinwondertaggroup/supplier/all",
  VIN_WONDER_TAGGROUP_FOLLOW_SUPPLIER: "/api/admin/tour/all",
  VIN_WONDER_TAGGROUP: "/api/vinwondertaggroup",
  VIN_WONDER_TAGGROUP_REORDER: "/api/vinwondertaggroup/reorder",
  VIN_WONDER_TAGGROUP_SET_DEFAULT: "/api/vinwondertaggroup/setdefault",
  VIN_WONDER_TAGGROUP_TRANSLATE_CREATE: "/api/vinwondertaggroup/translation",
  VIN_WONDER_TAGGROUP_TRANSLATE_UPDATE: "/api/vinwondertaggroup/translation",
  VIN_WONDER_TAGGROUP_TRANSLATE_DELETE: "/api/vinwondertaggroup/translation/:id",
  VIN_WONDER_TAGGROUP_AUTO_TRANSLATE: "/api/vinwondertaggroup/auto-translate",

  // Cache Redis
  CACHE_REDIS_GET: "/api/admin/cache/redis-key-patterns",
  CACHE_REDIS_DELETE: "/api/admin/cache/clear",
  
  //AI Translate
  CAMPAIGN_AUTO_TRANSLATE: "/api/admin/campaign/auto-translate",
  TAG_GROUP_AUTO_TRANSLATE: "/api/taggroupdetail/auto-translate",
  VW_TAG_GROUP_AUTO_TRANSLATE: "/api/vinwondertaggroup/auto-translate",
  SUPPLIER_AUTO_TRANSLATE: "/admin/supplier/auto-translate",
  TOUR_AUTO_TRANSLATE: "/admin/tour/auto-translate",
  TOUR_TICKET_AUTO_TRANSLATE: "/admin/tourTicket/auto-translate",
  HOTEL_AUTO_TRANSLATE: "/admin/hotels/auto-translate",
  ROOM_TYPE_AUTO_TRANSLATE: "/admin/roomtypes/auto-translate",
  RATE_PLAN_AUTO_TRANSLATE: "/api/admin/hotel/rate-plan/auto-translate",
  BOOKABLE_PACKAGE_RATE_AUTO_TRANSLATE:
    "/admin/bookable-package-rates/auto-translate",
  // FnB Sync
  FNB_OUTLET_LIST: "/admin/fnb/outlet",
  FNB_FRONTEND_PROPERTIES: "/frontend/fnb/properties",
  FNB_FRONTEND_OUTLETS: "/frontend/fnb/outlets",
  FNB_FRONTEND_MENUS: "/frontend/fnb/menus",
  FNB_FRONTEND_MENU_ITEMS: "/frontend/fnb/menu-item-lookup",
  FNB_OUTLET_UPDATE: "/admin/fnb/outlet",
  FNB_OUTLET_SYNC: "/admin/fnb/sync/outlets",
  FNB_MENU_LIST: "/admin/fnb/menu",
  FNB_MENU_DETAIL: "/admin/fnb/menu/:id",
  FNB_MENU_UPDATE: "/admin/fnb/menu",
  FNB_MENU_SYNC: "/admin/fnb/sync/menus",
  FNB_MENU_ITEM_SYNC: "/admin/fnb/sync/menu-items",
  FNB_MENU_ITEM_LIST: "/admin/fnb/menu-items/search-by-menu-id",
  FNB_MENU_ITEM_UPDATE: "/admin/fnb/menu-items",
  FNB_MENU_TRANSLATE: "/admin/fnb/menu/translate",
  FNB_MENU_TRANSLATE_DELETE: "/admin/fnb/menu/translate/:id",
  FNB_PROPERTY_LIST_ALL: "/admin/fnb/property/all",
  FNB_ITEM_DETAIL: "/api/fnb/items/:id",
  FNB_ITEM_SYNC: "/api/fnb/items/sync",
  FNB_PRODUCT_CONDIMENT_LIST: "/admin/fnb/product-condiment",
  FNB_PRODUCT_CONDIMENT_DETAIL: "/admin/fnb/product-condiment/:id",
  FNB_PRODUCT_CONDIMENT_UPDATE: "/admin/fnb/product-condiment",
  FNB_PRODUCT_CONDIMENT_SYNC: "/admin/fnb/sync/product-condiments",
  FNB_PRODUCT_CONDIMENT_TRANSLATE: "/admin/fnb/product-condiment/translate",
  FNB_PRODUCT_CONDIMENT_TRANSLATE_DELETE: "/admin/fnb/product-condiment/translate/:id",
  FNB_PRODUCT_OPTION_LIST: "/admin/fnb/product-option",
  FNB_PRODUCT_OPTION_DETAIL: "/admin/fnb/product-option/:id",
  FNB_PRODUCT_OPTION_UPDATE: "/admin/fnb/product-option",
  FNB_PRODUCT_OPTION_SYNC: "/admin/fnb/sync/product-options",
  FNB_PRODUCT_OPTION_TRANSLATE: "/admin/fnb/product-option/translate",
  FNB_PRODUCT_OPTION_TRANSLATE_DELETE: "/admin/fnb/product-option/translate/:id",
  FNB_PRODUCT_LIST: "/admin/fnb/product",
  FNB_PRODUCT_SYNC: "/admin/fnb/sync/products",
  FNB_PRODUCT_DETAIL: "/admin/fnb/product/:id",
  FNB_PRODUCT_UPDATE: "/admin/fnb/product",
  FNB_PRODUCT_TRANSLATE: "/admin/fnb/product/translate",
  FNB_PRODUCT_TRANSLATE_DELETE: "/admin/fnb/product/translate/:id",
  FNB_PRODUCT_DELETE: "/admin/fnb/product/:id"
};
